<a (click)="goBack()" class="text-body back-button" href="javascript:">
  <i class="icon icon-arrow-right mr-1"></i>
  <span>العودة</span>
</a>
